<ng-template #table>
  <table [attr.aria-label]="'GebäudeeingangsadresseAdressen' | translate" class="cap-table-detail">
    <thead>
      <tr>
        @if (!avPlusErweiterung) {
          <th>{{"Strasse" | translate}}</th>
        }
        @if (avPlusErweiterung) {
          <th>{{"StrasseBenanntesGebiet" | translate}}</th>
        }
        <th>{{"Haus-Nr." | translate}}</th>
        <th>{{"PlzOderOrtschaft" | translate}}</th>
        <th>{{"Gebaeudebezeichnung" | translate}}</th>
        <th>{{"EGID" | translate}}</th>
        <th>{{"EDID" | translate}}</th>
        @if (showKantDid) {
          <th>{{"BE-EDID" | translate}}</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (eingangAdresse of eingangAdressenVM | orderByEingangadresse; track eingangAdresse) {
        <tr>
          <td [capHistinfo]="eingangAdresse.version.histInfo">
            {{ eingangAdresse.version | kompaktVersionGebaeudeeingangsadresse: "STRASSE" }}
          </td>
          <td [capHistinfo]="eingangAdresse.version.histInfo">{{ eingangAdresse.version.hausnummer }}</td>
          <td>
            <span [capHistinfo]="eingangAdresse.version.histInfo">
              {{ eingangAdresse.version.plz }} {{ eingangAdresse.version.ortschaft }}
            </span>
            <cap-kompakt-timepoint [item]="eingangAdresse.version.histInfo?.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
          </td>
          <td [capHistinfo]="eingangAdresse.version.histInfo">{{ eingangAdresse.version.gebaeudeBezeichnung }}</td>
          <td [capHistinfo]="eingangAdresse.version.histInfo">{{ eingangAdresse.version.gwrEgid }}</td>
          <td [capHistinfo]="eingangAdresse.version.histInfo">{{ eingangAdresse.version.gwrEdid | formatEdid }}</td>
          @if (showKantDid) {
            <td [capHistinfo]="eingangAdresse.version.histInfo">{{ eingangAdresse.kantDid | formatBeEdid }}</td>
          }
        </tr>
      }
    </tbody>
  </table>
</ng-template>

@if (eingangAdressenVM.length == 0) {
  <ng-template [ngTemplateOutlet]="keine"></ng-template>
} @else {
  <table [attr.aria-label]="'GebäudeeingangsadresseAdressen' | translate" class="cap-table-detail">
    <thead>
      <tr>
        @if (!avPlusErweiterung) {
          <th>{{"Strasse" | translate}}</th>
        }
        @if (avPlusErweiterung) {
          <th>{{"StrasseBenanntesGebiet" | translate}}</th>
        }
        <th>{{"Haus-Nr." | translate}}</th>
        <th>{{"PlzOderOrtschaft" | translate}}</th>
        <th>{{"Gebaeudebezeichnung" | translate}}</th>
        <th>{{"EGID" | translate}}</th>
        <th>{{"EDID" | translate}}</th>
        @if (showKantDid) {
          <th>{{"BE-EDID" | translate}}</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (eingangAdresse of eingangAdressenVM | orderByEingangadresse; track eingangAdresse) {
        <tr>
          <td [capHistinfo]="eingangAdresse.version.histInfo">
            {{ eingangAdresse.version | kompaktVersionGebaeudeeingangsadresse: "STRASSE" }}
          </td>
          <td [capHistinfo]="eingangAdresse.version.histInfo">{{ eingangAdresse.version.hausnummer }}</td>
          <td>
            <span [capHistinfo]="eingangAdresse.version.histInfo">
              {{ eingangAdresse.version.plz }} {{ eingangAdresse.version.ortschaft }}
            </span>
            <cap-kompakt-timepoint [item]="eingangAdresse.version.histInfo?.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
          </td>
          <td [capHistinfo]="eingangAdresse.version.histInfo">{{ eingangAdresse.version.gebaeudeBezeichnung }}</td>
          <td [capHistinfo]="eingangAdresse.version.histInfo">{{ eingangAdresse.version.gwrEgid }}</td>
          <td [capHistinfo]="eingangAdresse.version.histInfo">{{ eingangAdresse.version.gwrEdid | formatEdid }}</td>
          @if (showKantDid) {
            <td [capHistinfo]="eingangAdresse.version.histInfo">{{ eingangAdresse.kantDid | formatBeEdid }}</td>
          }
        </tr>
      }
    </tbody>
  </table>
}
<ng-template #keine>
  <div class="mb-2">
    <span>{{"Keine" | translate}}</span>
  </div>
</ng-template>
